import React, { useContext, useEffect } from 'react';
import NewSideBar from '../../Components/MiniComponent/NewSideBar';
import Topnav from '../../Components/Topnav';
import { Route, Routes } from 'react-router-dom';
import { HrmStore } from '../../Context/HrmContext';
import FacebookConfigDashboard from './FacebookConfigDashboard';
import FacebookConfigForm from './FacebookConfigForm';

const FacebookRouter = () => {
  const { setActivePage } = useContext(HrmStore);
  
  useEffect(() => {
    setActivePage('facebook_config');
  }, [setActivePage]);

  return (
    <div>
      <main className="flex flex-col lg:flex-row">
        <article className="sticky z-10 top-0">
          <NewSideBar />
        </article>
        <article className="flex-1 container-fluid px-0 overflow-hidden mx-auto">
          <Topnav name="Facebook Integration" />
          <div className="p-2">
            <Routes>
              <Route path="/configuration" element={<FacebookConfigDashboard />} />
              <Route path="/configuration/form" element={<FacebookConfigForm />} />
              <Route path="/*" element={<FacebookConfigDashboard />} />
            </Routes>
          </div>
        </article>
      </main>
    </div>
  );
};

export default FacebookRouter;
